import { useEffect, useState } from 'react'
import { Alert, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material'
import { urlApi } from '../../config'
import { getAccessToken } from '../../auth'

const MUTED = 'text-gray-500 dark:text-gray-400'

const changeLobbyOwner = async (lobbyId, userId) => {
  try {
    const token = await getAccessToken()
    const response = await fetch(
      `${urlApi}/admin/lobbies/change-owner/${encodeURIComponent(lobbyId)}`,
      {
        method: 'PATCH',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          ...(typeof token === 'string' && { Authorization: `Bearer ${token}` })
        },
        body: JSON.stringify({ user_id: userId })
      }
    )
    const data = await response.json().catch(() => null)
    return { ok: response.ok, data }
  } catch (error) {
    console.error(error)
    return { ok: false, data: null }
  }
}

export default function ChangeOwnerDialog({ open, lobby, onClose, onChanged }) {
  const [userId, setUserId] = useState('')
  const [sending, setSending] = useState(false)
  const [problem, setProblem] = useState(null)

  useEffect(() => {
    if (!open) return
    setUserId('')
    setProblem(null)
  }, [open])

  const close = () => {
    if (!sending) onClose()
  }

  const submit = async () => {
    setSending(true)
    setProblem(null)
    const { ok, data } = await changeLobbyOwner(lobby._id, userId.trim())
    setSending(false)
    if (ok) {
      onChanged(data)
      return
    }
    setProblem(data?.message || 'No se pudo cambiar el conductor')
  }

  return (
    <Dialog open={open} onClose={close} fullWidth maxWidth='sm'>
      <DialogTitle>Cambiar conductor</DialogTitle>
      <DialogContent>
        <div className='flex flex-col gap-4 pt-1'>
          <dl className='grid grid-cols-[auto,1fr] gap-x-4 gap-y-1 text-sm'>
            <dt className={MUTED}>Conductor actual</dt>
            <dd className='break-words'>{lobby.Owner_info.first_name}</dd>
            <dt className={MUTED}>ID</dt>
            <dd className='font-mono break-all'>{lobby.Owner_info.id}</dd>
          </dl>

          <TextField
            size='small'
            label='ID del nuevo conductor'
            value={userId}
            onChange={event => setUserId(event.target.value)}
            onKeyDown={event => {
              if (event.key === 'Enter' && userId.trim() && !sending) submit()
            }}
            disabled={sending}
            autoFocus
            fullWidth
          />

          <p className={`text-sm ${MUTED}`}>
            El viaje, sus acompañantes y el chat grupal pasan al nuevo conductor, y el pago se le
            hace a él cuando se concrete. Los chats directos quedan con el conductor anterior.
          </p>

          {problem && <Alert severity='error'>{problem}</Alert>}
        </div>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <button
          className='px-3 py-2 rounded-lg text-sm hover:bg-gray-100 dark:hover:bg-dk-hover disabled:opacity-50'
          onClick={close}
          disabled={sending}
        >
          Cancelar
        </button>
        <button
          className='px-3 py-2 rounded-lg text-sm font-semibold bg-primary text-white hover:opacity-90 transition-opacity disabled:opacity-50'
          onClick={submit}
          disabled={sending || !userId.trim()}
        >
          {sending ? 'Cambiando…' : 'Cambiar conductor'}
        </button>
      </DialogActions>
    </Dialog>
  )
}
